import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteDataItemDocument } from './delete.generated';

export const useDeleteDataItem = (options: ApiOptions<typeof DeleteDataItemDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(DeleteDataItemDocument, {
    ...useNotifications(DeleteDataItemDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.data_items.delete_success'),
    }),
    ...options,
  });
};
